import { environmentDefaults } from './environment.default';

export const environment = {
    ...environmentDefaults,
    debug: false,
    name: 'prod'
};
